import {
  DriversLicenseFront,
  DriversLicenseBack,
  IdentityCardFront,
  IdentityCardBack,
  ResidencePermitFront,
  ResidencePermitBack,
  Passport,
} from "components/KYC2/graphics";

/**
 * @typedef MobileUploadConfigs
 * @type Object.<string, MobileUploadConfig>
 */
const uploadConfigs = {
  DL: {
    title: "Capture your driver's license",
    description: "Let's snap some photos of the front and back of your driver's license. When we're done capturing your document, head back to your other device to finish.",
    items: [
      {
        refId: "documents.document_front",
        PlaceHolderImage: DriversLicenseFront,
        buttonText: "Capture front",
        imageAlt: "Capture driver's license front",
      },
      {
        refId: "documents.document_back",
        PlaceHolderImage: DriversLicenseBack,
        buttonText: "Capture back",
        imageAlt: "Capture driver's license back",
      },
    ]
  },
  IC: {
    title: "Capture your identity card",
    description: "Let's snap some photos of the front and back of your identity card. When we're done capturing your document, head back to your other device to finish.",
    items: [
      {
        refId: "documents.document_front",
        PlaceHolderImage: IdentityCardFront,
        buttonText: "Capture front",
        imageAlt: "Capture identity card front",
      },
      {
        refId: "documents.document_back",
        PlaceHolderImage: IdentityCardBack,
        buttonText: "Capture back",
        imageAlt: "Capture identity card back",
      },
    ]
  },
  RP: {
    title: "Capture your residence permit",
    description: "Let's snap some photos of the front and back of your residence permit. When we're done capturing your document, head back to your other device to finish.",
    items: [
      {
        refId: "documents.document_front",
        PlaceHolderImage: ResidencePermitFront,
        buttonText: "Capture front",
        imageAlt: "Capture residence permit front",
      },
      {
        refId: "documents.document_back",
        PlaceHolderImage: ResidencePermitBack,
        buttonText: "Capture back",
        imageAlt: "Capture residence permit back",
      },
    ]
  },
  PP: {
    title: "Capture your passport",
    description: "Let's snap a photo of your passport. When we're done capturing your document, head back to your other device to finish.",
    items: [
      {
        refId: "documents.document_front",
        PlaceHolderImage: Passport,
        buttonText: "Capture passport",
        imageAlt: "Capture passport",
      },
    ]
  },
};

export default uploadConfigs;
